var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "EmdFormGroup",
        {
          attrs: {
            label: _vm.$t("recipients.create.name"),
            required: "",
            state: _vm.getState(_vm.$v.recipient.name),
            feedbacks: _vm.feedbacks(_vm.$v.recipient.name),
          },
        },
        [
          _vm.canEdit
            ? _c("EmdInput", {
                attrs: {
                  name: "recipient_name",
                  readonly: _vm.disabled,
                  disabled: _vm.disabled,
                },
                on: { input: _vm.$v.recipient.name.$touch },
                model: {
                  value: _vm.recipient.name,
                  callback: function ($$v) {
                    _vm.$set(_vm.recipient, "name", $$v)
                  },
                  expression: "recipient.name",
                },
              })
            : _c("span", [_vm._v(_vm._s(_vm.recipient.name))]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }